import { QueryHookOptions, useQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { Queries } from '@shared/api';
import { API } from '@shared/types/api';

export function useCard(
  id?: string,
  options: Partial<QueryHookOptions<API.CardDetailsQuery, API.CardDetailsQueryVariables>> = {},
): {
  card?: API.CardDetailsQuery['card'];
  loading: boolean;
  error?: Error;
} {
  const { data, loading, error } = useQuery<API.CardDetailsQuery, API.CardDetailsQueryVariables>(
    Queries.card.details,
    {
      ...options,
      variables: { id: id! },
      skip: isNil(id),
    },
  );
  return { loading, card: data?.card, error };
}
